module.exports = __webpack_public_path__ + "static/media/Vancouver_Canucks.c8ee873e.svg";